import { useStoreState } from 'base/store';
import {
    ContactEmail,
    ContactPhone,
} from '@base/common/Contact';
import site from 'pro/config/site';
import styles from '@pro/help/default.module.less';
import { CompanyInformation } from '@pro/help/ContactUs/CompanyInformation';

export default function Content() {
    const { host } = useStoreState('rootStore');

    return (
        <div className={styles.help}>
            <h1>Contact Us</h1>
            <div className="text-center">
                <p>
                    <strong>{host.replace(/^(.*)\.([\w-]+\.\w+)$/, '$2')} Questions:</strong><br/>
                    <ContactEmail/>
                </p>
                <p>
                    <strong>Influencer and Partnerships:</strong><br/>
                    <ContactEmail type={'market'}/>
                </p>
                <p>
                    <strong>Affiliate Program Inquiries:</strong><br/>
                    <ContactEmail type={'affiliate'}/>
                </p>
                <p>
                    <strong>Bulk Order/Wholesale Questions:</strong><br/>
                    <ContactEmail type={'wholesale'}/>
                </p>
                <p>
                    <strong>Amazon-related Questions:</strong><br/>
                    <ContactEmail type={'amazon'}/>
                </p>
                <p>
                    Or call us :<br/>
                    <strong><ContactPhone/></strong><br/>
                    {site.contact.phone.onlineTime}
                </p>

                <p>
                    <strong>Company Information:</strong>
                    <br />
                    <CompanyInformation />
                </p>
            </div>
        </div>
    )
};